import * as React from 'react'
import {ReactNode} from 'react'
import {BlockSpacer} from '../../../../../styledComponents/ResponsiveConvenience'
import {APPLY_CATEGORY} from '../../../../../CodeMaster'
import {convertToRoomNumberForResident} from '../../../../common/util/Natutil'
import {
    NatResidentLoginInfoSessionStorageHelper,
    ResidentLoginInfoSessionStorageKey
} from '../../../../common/authentication/NatResidentLoginInfoSessionStorageHelper'
import NatResidentApplicationDetailConfirmItem from '../../common/resident/NatResidentApplicationDetailConfirmItem'
import {getFormattedAddress} from '../../contactAddressOnEmergencies/helper/NatContactAddressOnEmergencyHelper'
import {NatBrowseApplyAccompany, NatBrowseApplyTime} from '../NatResidentApplicationInterface'
import {formatDate} from '../../../../../formatters/formatDate'
import {getFormattedTime} from '../helper/NatBrowseApplyHelper'
import {Nullable} from '../../../../../app/TypeHelpers'

interface Props {
    applicantFamilyName: string
    applicantFirstName: string
    browseReasonDetail: string
    videoRecordingPlace: string
    videoRecordingDate: string
    videoRecordingStartTime: NatBrowseApplyTime
    videoRecordingEndTime: NatBrowseApplyTime
    browsePreferredDate: string
    browsePreferredStartTime: NatBrowseApplyTime
    browsePreferredEndTime: NatBrowseApplyTime
    accompany: Nullable<NatBrowseApplyAccompany[]>
    note: Nullable<string>
    applyFlag?: boolean
}

const NatResidentBrowseConfirm = ({applyFlag = true, ...otherProps}: Props) => {
    const {
        applicantFamilyName,
        applicantFirstName,
        browseReasonDetail,
        videoRecordingPlace,
        videoRecordingDate,
        videoRecordingStartTime,
        videoRecordingEndTime,
        browsePreferredDate,
        browsePreferredStartTime,
        browsePreferredEndTime,
        accompany,
        note,
    } = otherProps

    const applyCategoryLabel = APPLY_CATEGORY.INSPECTION_APPLY.label
    const applicantRoom = NatResidentLoginInfoSessionStorageHelper
            .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_NAME) + '　' +
        NatResidentLoginInfoSessionStorageHelper
            .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_RIDGENAME) + ' ' +
        convertToRoomNumberForResident(
            NatResidentLoginInfoSessionStorageHelper
                .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_ROOM_NUMBER)
        )

    const accompanyInfo = (accompanies: NatBrowseApplyAccompany[]): ReactNode => {
        const renderDetail: ReactNode[] = []

        accompanies.forEach((record, key) => {
            const items = []
            items.push(`同行者名：${record.accompanyName ?? ''}`)
            items.push(`続柄：${record.relationship ?? ''}`)
            items.push(`住所：${getFormattedAddress(
                    record.zipCode ?? '',
                    record.prefecture ?? '',
                    record.address2 ?? '',
                    record.address3 ?? '',
                    record.buildingRoomNumber ?? ''
                )}`
            )

            renderDetail.push(
                <React.Fragment key={key}>
                    <NatResidentApplicationDetailConfirmItem
                        title={`同行者${key + 1}`}
                        items={items}
                    />
                    <BlockSpacer height={'5px'}/>
                </React.Fragment>
            )
        })

        return <>
            {renderDetail}
        </>
    }


    return (<>
        {applyFlag === true &&
            <>
                <NatResidentApplicationDetailConfirmItem
                    title={'申請区分'}
                    items={[applyCategoryLabel]}
                />
                <BlockSpacer height={'5px'}/>
                <NatResidentApplicationDetailConfirmItem
                    title={'申請者'}
                    items={[applicantRoom, `${applicantFamilyName} ${applicantFirstName}`]}
                />
            </>
        }
        <BlockSpacer height={'5px'}/>
        <NatResidentApplicationDetailConfirmItem
            title={'閲覧理由の詳細'}
            items={[browseReasonDetail]}
        />
        <BlockSpacer height={'5px'}/>
        <NatResidentApplicationDetailConfirmItem
            title={'閲覧したい録画映像'}
            items={[
                `場所：${videoRecordingPlace}`,
                `日付：${formatDate(videoRecordingDate)}`,
                `開始時間：${getFormattedTime(videoRecordingDate, videoRecordingStartTime.time)}`,
                `終了時間：${getFormattedTime(videoRecordingDate, videoRecordingEndTime.time)}`
            ]}
        />
        <BlockSpacer height={'5px'}/>
        <NatResidentApplicationDetailConfirmItem
            title={'閲覧の希望日時'}
            items={[
                `日付：${formatDate(browsePreferredDate)}`,
                `開始時間：${getFormattedTime(browsePreferredDate, browsePreferredStartTime.time)}`,
                `終了時間：${getFormattedTime(browsePreferredDate, browsePreferredEndTime.time)}`
            ]}
        />
        <BlockSpacer height={'5px'}/>
        {accompany && accompanyInfo(accompany)}
        <NatResidentApplicationDetailConfirmItem
            title={'備考'}
            items={[note ?? '']}
        />
    </>)
}

NatResidentBrowseConfirm.displayName = 'NatResidentBrowseConfirm'
export default NatResidentBrowseConfirm